var Layers = /*#__PURE__*/function () {
  function Layers() {
    this.mask = 1 | 0;
  }

  var _proto = Layers.prototype;

  _proto.set = function set(channel) {
    this.mask = 1 << channel | 0;
  };

  _proto.enable = function enable(channel) {
    this.mask |= 1 << channel | 0;
  };

  _proto.enableAll = function enableAll() {
    this.mask = 0xffffffff | 0;
  };

  _proto.toggle = function toggle(channel) {
    this.mask ^= 1 << channel | 0;
  };

  _proto.disable = function disable(channel) {
    this.mask &= ~(1 << channel | 0);
  };

  _proto.disableAll = function disableAll() {
    this.mask = 0;
  };

  _proto.test = function test(layers) {
    return (this.mask & layers.mask) !== 0;
  };

  return Layers;
}();

export { Layers };